import MyTinySlider from './MyTinySlider';
import { onDomReady } from '../../components/dynamic/observer';
import bindArrows from './common/bindArrows';
import sliderCounter from './common/sliderCounter';
import updateFilling from './common/updateFilling';

onDomReady(() => {
  const heroSliderContainers = document.querySelectorAll('[data-hero-project-slider-container]');

  heroSliderContainers.forEach((heroSliderContainer) => {
    const autoOff = heroSliderContainer.hasAttribute('data-auto-off');
    const showNav = heroSliderContainer.hasAttribute('data-show-nav');

    const items = Array.from(heroSliderContainer.querySelectorAll('[data-hero-project-item]'));
    const textWrap = heroSliderContainer.querySelector('[data-hero-project-text]');
    const closeButton = heroSliderContainer.querySelector('[data-hero-project-close]');
    const mainHeroInfos = heroSliderContainer.querySelectorAll('[data-main-hero-info]');

    const heroSlider = new MyTinySlider({
      sliderContainer: heroSliderContainer,
      sliderList: '[data-hero-project-slider]',
      arrowLeft: '[data-hero-project-left]',
      arrowRight: '[data-hero-project-right]',
      slideIndex: '[data-hero-project-slider-index]',
      slideCount: '[data-hero-project-count]',
      slideBy: 1,
      items: 1,
      mode: 'gallery',
      animateIn: 'plug-class-first',
      animateOut: 'plug-class-second',
      animateNormal: 'plug-class-normal',
      nav: showNav,
      speed: 1500,
      controls: false,
      rewind: false,
      loop: false,
      mouseDrag: true,
      autoplayButtonOutput: false,
      preventActionWhenRunning: true,
    });

    let autoSlideInterval;

    const resetAutoSlide = () => {
      if (autoSlideInterval) {
        clearInterval(autoSlideInterval);
      }
      if (!autoOff) {
        autoSlideInterval = setInterval(() => {
          const info = heroSlider.slider.getInfo();
          if (info.index + 1 < info.slideCount) {
            console.log('auto slide');
            const rightButton = heroSliderContainer.querySelector('[data-hero-project-right]');
            if (rightButton) {
              rightButton.click();
            }
          }
        }, 9000);
      }
    };

    resetAutoSlide();

    const leftButton = heroSliderContainer.querySelector('[data-hero-project-left]');
    const rightButton = heroSliderContainer.querySelector('[data-hero-project-right]');

    if (leftButton && rightButton) {
      bindArrows(
        '[data-hero-project-left]',
        '[data-hero-project-right]',
        heroSlider.slider,
        heroSliderContainer,
        resetAutoSlide, // Pass the reset function to bindArrows
      );
    }

    const sliderIndex = heroSliderContainer.querySelector('[data-hero-project-slider-index]');
    const sliderCount = heroSliderContainer.querySelector('[data-hero-project-count]');

    if (sliderIndex && sliderCount) {
      sliderCounter(
        heroSliderContainer,
        '[data-hero-project-slider-index]',
        '[data-hero-project-count]',
        heroSlider.slider,
      );
    }

    const setActiveItem = (info) => {
      const displayIndex = parseInt(info.displayIndex, 10);
      const currentItem = items.find(item => parseInt(item.dataset.heroSlideNumber, 10) === displayIndex);
      const prevItem = items.find(item => item.classList.contains('_active'));
      const prevIndex = prevItem ? parseInt(prevItem.dataset.heroSlideNumber, 10) : null;

      // Remove active from previous if it's different
      if (prevItem && prevItem !== currentItem) {
        prevItem.classList.remove('_active');
      }

      // Ensure current is active and update related info
      if (currentItem) {
        currentItem.classList.add('_active');
        setMainHeroInfoActive(currentItem);
      }

      // If we have both items and they differ, animate according to direction
      if (prevItem && currentItem && prevItem !== currentItem) {
        if (displayIndex > prevIndex) {
          next(currentItem, prevItem);
        } else {
          prev(currentItem, prevItem);
        }
      } else if (!prevItem && currentItem) {
        // initial state: normalize classes
        addClasses();
      }

      if (textWrap) {
        if (displayIndex !== 1) {
          if (!textWrap.classList.contains('_close')) {
            textWrap.classList.add('_close');
          }
        } else if (textWrap.classList.contains('_close')) {
          textWrap.classList.remove('_close');
        }
      }
    };

    const setMainHeroInfoActive = (activeSlide) => {
      mainHeroInfos.forEach((mainHeroInfo) => {
        if (mainHeroInfo.classList.contains('_active')) {
          mainHeroInfo.classList.remove('_active');
        }
        if (activeSlide.dataset.heroSlideNumber === mainHeroInfo.dataset.mainHeroInfo) {
          setTimeout(() => {
            mainHeroInfo.classList.add('_active');
          }, 800);
        }
      });
    };

    const next = (currentItem, prevItem) => {
      if (!prevItem || !currentItem) return;
      prevItem.classList.remove('_active', '_animate-in-next', '_animate-in-prev');
      prevItem.classList.add('_animate-out-next');
      currentItem.classList.remove('_animate-normal-next');
      currentItem.classList.add('_animate-in-next', '_active');

      setTimeout(() => {
        prevItem.classList.remove('_animate-out-next');
        prevItem.classList.add('_animate-normal-prev');
      }, 1500);
    };

    const prev = (currentItem, prevItem) => {
      if (!prevItem || !currentItem) return;
      prevItem.classList.remove('_active', '_animate-in-next', '_animate-in-prev');
      prevItem.classList.add('_animate-out-prev');
      currentItem.classList.remove('_animate-normal-prev');
      currentItem.classList.add('_animate-in-prev', '_active');

      setTimeout(() => {
        prevItem.classList.remove('_animate-out-prev');
        prevItem.classList.add('_animate-normal-next');
      }, 1500);
    };

    const addClasses = () => {
      items.forEach((item, index) => {
        if (index !== 0) {
          item.classList.remove('_animate-normal-prev');
          item.classList.add('_animate-normal-next');
        }
      });
    };

    if (heroSlider.slider) {
      heroSlider.slider.events.on('indexChanged', (info) => {
        updateFilling(info);
        resetAutoSlide(); // Reset timer on manual slide change
      });
      updateFilling(heroSlider.slider.getInfo());

      heroSlider.slider.events.on('transitionStart', (info) => {
        setActiveItem(info);
        resetAutoSlide(); // Reset timer on manual slide change
      });

      if (closeButton) {
        closeButton.addEventListener('click', () => {
          heroSlider.slider.goTo(0);
          addClasses();
          resetAutoSlide(); // Reset timer on manual interaction
        });
      }
    }
  });
});